<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div></div>
        <div class="card card-competencias">          
          <div class="card-content">            
            <div class="row">
              <div class="col-md-12">
                <h4 class="card-title">Matriz de Desenvolvimento</h4>
              </div>
              <div class="col-md-12">
                <div class="matrix">
                  <div class="matrix-left-title"><span>DESEMPENHO</span></div>
                  <div class="matrix-content">
                    <div class="matrix-row">
                      <div class="matrix-label"><span>Acima do esperado</span></div>
                      <div class="matrix-card matrix-card-blue-1">
                        <div class="matrix-card-title">Acima do esperado - 101 a 107.3</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Desempenho frequentemente acima do esperado.</li>
                            <li>Entrega além da expectativa para a função e contribui com melhorias para suas atividades.</li>
                            <li>Possui elevada competência em seu cargo e está aprimorando outras adicionais.</li>
                            <li>Pode apoiar e ser desenvolvido em novos desafios, além da sua função.</li>
                          </ul>
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-blue-2">
                        <div class="matrix-card-title">Acima do esperado - 107 a 113.7</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Desempenho sempre acima do esperado.</li>
                            <li>É referência na função atual e na condução de melhorias para sua área.</li>
                            <li>Possui elevada competência em seu cargo e já está em consolidação de outras adicionais.</li>
                            <li>Pode conduzir alguns desafios, além da sua função, e deve ser preparado para o seu próximo passo de carreira.</li>
                          </ul>                          
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-blue-3">
                        <div class="matrix-card-title">Acima do esperado 113.8 a 120</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Desempenho supera o esperado consistentemente.</li>
                            <li>É expert em sua função, possui competências adicionais e atua em melhorias/inovação para sua área, diretoria e para a empresa.</li>
                            <li>Está pronto para assumir novos cargos com escopo e responsabilidades mais amplos e complexos.</li>
                            <li>É reconhecido por colegas e gestores para o seu próximo passo e/ou como sucessor de sua área.</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="matrix-row">
                      <div class="matrix-label"><span>Dentro do esperado</span></div>
                      <div class="matrix-card matrix-card-green-1">
                        <div class="matrix-card-title">Dentro do esperado - 80 a 86.5</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Desempenho satisfatório, mas eventualmente apresenta alguma inconsistência e pode não atender a todos os requisitos esperados para a sua entrega.</li>
                            <li>Apresenta as competências para a função, mas necessita consolidá-las e fortalecer a sua atuação.</li>
                          </ul>
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-green-2">
                        <div class="matrix-card-title">Dentro do esperado - 86.5 a 94</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Desempenho satisfatório.</li>
                            <li>Entrega o esperado para a função, de forma completa, dentro do prazo e  padrão de qualidade.</li>
                            <li>Está consolidado nas competências de seu cargo e possui resultados consistentes.</li>
                          </ul>
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-green-3">
                        <div class="matrix-card-title">Dentro do esperado - 94.1 a 100.9</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Desempenho satisfatório e ocasionalmente acima do esperado.</li>
                            <li>Entrega o esperado para a função, de forma completa, no prazo e com qualidade, e consegue lidar com situações atípicas.</li>
                            <li>Consolidado nas competências de seu cargo e em desenvolvimento de outras adicionais.</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="matrix-row">
                      <div class="matrix-label"><span>Abaixo do esperado e <br> Em desenvolvimento</span></div>
                      <div class="matrix-card matrix-card-red-1">
                        <div class="matrix-card-title">Abaixo de esperado - 0 a 25</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Baixo desempenho.</li>
                            <li>Raramente entrega resultados e normalmente incompletos, fora do prazo e padrão de qualidade.</li>
                            <li>Padrão de qualidade abaixo do esperado.</li>
                            <li>Possui competências em nível insuficiente para a sua função.</li>
                            <li>Priorizar feedback assertivo e execução do PDI.</li>
                          </ul>
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-red-2">
                        <div class="matrix-card-title">Abaixo de esperado - 25.1 a 50.9</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Desempenho Inconsistente e competências em nivel muito básico para a função.</li>
                            <li>Oscila em suas entregas, normalmente finalizando-as de maneira incompleta, fora do prazo e padrão de qualidade.</li>
                            <li>Apresenta dificuldades de adaptação.</li>
                          </ul>                          
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-yellow-3">
                        <div class="matrix-card-title">Em desenvolvimento - 51 a 79.9</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Desempenho parcialmente satisfatório.</li>
                            <li>Está em desenvolvimento na função atual e consolidação de suas competências.</li>
                            <li>Oscila em suas entregas, mas normalmente sçao concluídas dew forma completa, no prazo e com a qualidade esperada.</li>
                            <li>Apresenta alto potencial, mas precisa melhorar seu desempenho.</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="matrix-bottom-title"><span>POTENCIAL</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div></div>
        <div class="card card-competencias">          
          <div class="card-content">            
            <div class="row">
              <div class="col-md-12">
                <h4 class="card-title">Resultado do Colaborador</h4>
              </div>
              <div class="col-md-12">
                <div class="matrix matrix-result">
                  <div class="matrix-left-title"><span>DESEMPENHO</span></div>
                  <div class="matrix-content">
                    <div class="matrix-row">
                      <div class="matrix-label"><span>Acima do esperado</span></div>
                      <div class="matrix-card matrix-card-blue-1">
                        <div class="matrix-card-title">Acima do esperado</div>
                        <div class="matrix-card-content">
                          <span class="scale-result">101 a 107.3</span>
                          <span v-if="((resultEvaluation.final_result >= 101) && (resultEvaluation.final_result <= 107.3))" class="label-result">
                            <strong>{{ resultEvaluation.collaborator.name }}</strong>
                          </span>
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-blue-2">
                        <div class="matrix-card-title">Acima do esperado</div>
                        <div class="matrix-card-content">
                          <span class="scale-result">107.4 a 113.7</span>
                          <span v-if="((resultEvaluation.final_result >= 107.4) && (resultEvaluation.final_result <= 113.7))" class="label-result">
                            <strong>{{ resultEvaluation.collaborator.name }}</strong>
                          </span>                       
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-blue-3">
                        <div class="matrix-card-title">Acima do esperado</div>
                        <div class="matrix-card-content">
                          <span class="scale-result">113.8 a 120</span>
                          <span v-if="((resultEvaluation.final_result >= 113.8) && (resultEvaluation.final_result <= 120))" class="label-result">
                            <strong>{{ resultEvaluation.collaborator.name }}</strong>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="matrix-row">
                      <div class="matrix-label"><span>Dentro do esperado</span></div>
                      <div class="matrix-card matrix-card-green-1">
                        <div class="matrix-card-title">Dentro do esperado</div>
                        <div class="matrix-card-content">
                          <span class="scale-result">80 a 86.5</span>
                          <span v-if="((resultEvaluation.final_result >= 80) && (resultEvaluation.final_result <= 86.5))" class="label-result">
                            <strong>{{ resultEvaluation.collaborator.name }}</strong>
                          </span>
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-green-2">
                        <div class="matrix-card-title">Dentro do esperado</div>
                        <div class="matrix-card-content">
                          <span class="scale-result">86.6 a 94</span>
                          <span v-if="((resultEvaluation.final_result >= 86.6) && (resultEvaluation.final_result <= 94))" class="label-result">
                            <strong>{{ resultEvaluation.collaborator.name }}</strong>
                          </span>
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-green-3">
                        <div class="matrix-card-title">Dentro do esperado</div>
                        <div class="matrix-card-content">
                          <span class="scale-result">94.1 a 100.9</span>
                          <span v-if="((resultEvaluation.final_result >= 94.1) && (resultEvaluation.final_result <= 100.9))" class="label-result">
                            <strong>{{ resultEvaluation.collaborator.name }}</strong>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="matrix-row">
                      <div class="matrix-label"><span>Abaixo do esperado e <br> em desenvolvimento</span></div>
                      <div class="matrix-card matrix-card-red-1">
                        <div class="matrix-card-title">Abaixo de esperado</div>
                        <div class="matrix-card-content">
                          <span class="scale-result">0 a 25</span>
                          <span v-if="((resultEvaluation.final_result >= 0) && (resultEvaluation.final_result <= 25))" class="label-result">
                            <strong>{{ resultEvaluation.collaborator.name }}</strong>
                          </span>
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-red-2">
                        <div class="matrix-card-title">Abaixo de esperado</div>
                        <div class="matrix-card-content">
                          <span class="scale-result">25.1 a 50.9</span>
                          <span v-if="((resultEvaluation.final_result >= 25.1) && (resultEvaluation.final_result <= 50.9))" class="label-result">
                            <strong>{{ resultEvaluation.collaborator.name }}</strong>
                          </span>                    
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-yellow-3">
                        <div class="matrix-card-title">Em desenvolvimento</div>
                        <div class="matrix-card-content">
                          <span class="scale-result">51 a 79.9</span>
                          <span v-if="((resultEvaluation.final_result >= 51) && (resultEvaluation.final_result <= 79.9))" class="label-result">
                            <strong>{{ resultEvaluation.collaborator.name }}</strong>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="matrix-bottom-title"><span>POTENCIAL</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div></div>
        <div class="card card-competencias">          
          <div class="card-content">            
            <div class="row">
              <div class="col-md-12">
                <h4 class="card-title">Orientações para o PDI</h4>
              </div>
              <div class="col-md-12">
                <div class="matrix">
                  <div class="matrix-left-title"><span>DESEMPENHO</span></div>
                  <div class="matrix-content">
                    <div class="matrix-row">
                      <div class="matrix-label"><span>Acima do esperado</span></div>
                      <div class="matrix-card matrix-card-blue-1">
                        <div class="matrix-card-title">Acima do esperado - 101 a 107.3</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Reconhecer a evolução das entregas e estimular o desenvolvimento de novas competências que alavanquem o seu potencial para um próximo passo de carreira.</li>
                            <li>Apoiar em demandas de melhoria dos processos/fluxos e projetos de sua função e área.</li>
                            <li>Treinar e orientar novos colaboradores da área.</li>
                            <li>Realizar acompanhamento periódico.</li>
                          </ul>
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-blue-2">
                        <div class="matrix-card-title">Acima do esperado - 107.4 a 113.7</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Reforçar o avanço em seu potencial e estabelecer um PDI focado no próximo passo de carreira.</li>
                            <li>Ser referência em sua função, para a equipe e demais colaboradores/gestores, e conduzir projetos e demandas de melhoria  para a área/diretoria.</li>
                            <li>Treinar e orientar novos colaboradores da área.</li>
                            <li>Realizar acompanhamento periódico.</li>
                          </ul>                          
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-blue-3">
                        <div class="matrix-card-title">Acima do esperado - 113.8 a 120</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Validar que está pronto para o próximo passo de carreira e/ou para assumir a sucessão da área atual.</li>
                            <li>Ser expert na função, dar suporte para sua gestão e participar de projetos gerais de melhoria.</li>
                            <li>Ser incluído e apoiar em fóruns/comitês de estrategia e inovação em sua área/diretoria.</li>
                            <li>Dar visibilidade ao colaborador, reconhecer e movimenta-lo</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="matrix-row">
                      <div class="matrix-label"><span>Dentro do esperado</span></div>
                      <div class="matrix-card matrix-card-green-1">
                        <div class="matrix-card-title">Dentro do esperado - 80 a 86.5</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Reconhecer as competências e entregas dentro do esperado e sinalizar as que necessitam de aprimoramento para sua consolidação na função.</li>
                            <li>Entender as dificuldades/necessidades do colaborador e elaborar um PDI focado em ações práticas e no acompanhamento de colegas mais experientes e referências na área.</li>
                            <li>Realizar acompanhamento periódico.</li>
                          </ul>
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-green-2">
                        <div class="matrix-card-title">Dentro do esperado - 86.6 a 94</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Reconhecer o desempenho satisfatório e a evolução do colaborador e estimulá-lo a novos aprendizados e desafios em sua função atual.</li>
                            <li>Direcionar para atividades diferentes das que já realiza e aumentar suas responsabilidades na área.</li>
                            <li>Elaborar PDI para incentivo e apoio a novas atribuições e realizar acompanhamento periódico.</li>
                          </ul>
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-green-3">
                        <div class="matrix-card-title">Dentro do esperado - 94.1 a 100.9</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Reforçar o alto potencial do colaborador e mapear junto a ele ações teóricas e práticas, de continuidade para seu desenvolvimento de suas competências e entregas.</li>
                            <li>Atribuir a ele atividades com maior escopo e complexidade e/ou identificar possibilidades de movimentação lateral para novas funções dentro do seu nível de atuação.</li>
                            <li>Realizar acompanhamento periódico.</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="matrix-row">
                      <div class="matrix-label"><span>Abaixo do esperado e <br> em desenvolvimento</span></div>
                      <div class="matrix-card matrix-card-red-1">
                        <div class="matrix-card-title">Abaixo de esperado - 0 a 25</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Realizar feedback formal, reforçando o desempenho insatisfatório e entendendo o grau de interesse e comprometimento do colaborador com as melhorias necessárias.</li>
                            <li>Estabelecer em conjunto um PDI de curto prazo, focado nos pontos mais críticos de desenvolvimento e realizar acompanhamento periódico até a conclusão.</li>
                            <li>Caso não haja melhoria, considerar desligamento.</li>
                          </ul> 
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-red-2">
                        <div class="matrix-card-title">Abaixo de esperado - 25.1 a 50.9</div>
                        <div class="matrix-card-content">
                           <ul>
                            <li>Realizar feedback formal sobre o baixo desempenho e competências críticas a desenvolver e entender os obstáculos e motivadores do colaborador.</li>
                            <li>Identificar a compatibilidade com as atividades exercidas e definir um PDI de médio prazo para as principais questões de melhoria.</li>
                            <li>Avaliar a viabilidade de uma mudança de atividade/escopo de atuação/função (job rotation).</li>
                          </ul>                          
                        </div>
                      </div>
                      <div class="matrix-card matrix-card-yellow-3">
                        <div class="matrix-card-title">Em desenvolvimento - 51 a 79.9</div>
                        <div class="matrix-card-content">
                          <ul>
                            <li>Orientar o colaborador com clareza sobre o seu papel, o que é esperado e quais as suas metas.</li>
                            <li>Capacitar na função com o apoio dos materiais disponíveis (políticas da CIA, processos e fluxos da área) e de treinamentos on-the-job com colaboradores referência na área.</li>
                            <li>Realizar acompanhamento e feedbacks periódicos.</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="matrix-bottom-title"><span>POTENCIAL</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> 
</template>
<script>
  export default {
    name: 'info-pdi-9box',
    props: {
      resultEvaluation: Object
    }
  }
</script>
<style>
.matrix {
  display: grid;
  grid-template-columns: 35px 1fr;
}

.matrix .matrix-content {
  border-left: 1px solid black;
  border-bottom: 1px solid black;
}

.matrix-left-title {
  text-align: center;
  writing-mode: vertical-rl;
  font-size: 16px;
  color: red;
  margin-bottom: 5px;
}

.matrix-left-title span {
  display: block;
  font-weight: 700;
  transform: rotate(180deg);
}

.matrix-bottom-title {
  text-align: center;
  font-size: 16px;
  color: red;
  margin-top: 5px;
  grid-column-start: 1;
  grid-column-end: 4;
  grid-row-start: 3;
  grid-row-end: 2;
}

.matrix-bottom-title span {
  display: block;
  font-weight: 700;
}

.matrix-row {
  display: grid;
  grid-template-columns: 35px repeat(3, 1fr);
}

.matrix-label {
  text-align: center;
  writing-mode: vertical-rl;
}

.matrix-label span {
  display: block;
  transform: rotate(180deg);
}

.matrix-label span {
  direction: ltr;
}

.matrix-card {
  padding: 3px;
}

.matrix-card-title {
  margin: 5px;
  padding: 10px;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}

.matrix-card-content {
  position: relative;
  height: 220px;
  margin: 5px;
  padding: 10px;
  font-size: 12px;
  overflow-y: scroll;
}

.matrix-card-content span.scale-result {
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 10px;
  margin-right: 10px;
  font-size: 12px;
  text-align: right;
  font-weight: 600;
}

.matrix-card-content::-webkit-scrollbar {
  width: 0.5em;
}

.matrix-card-content::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}

.matrix-card-blue-1 > .matrix-card-content, .matrix-card-blue-1 > .matrix-card-title {
  background-color: rgb(0, 208, 0);
}

.matrix-card-blue-2 > .matrix-card-content, .matrix-card-blue-2 > .matrix-card-title {
  background-color: rgb(0, 162, 0);
}

.matrix-card-blue-3 > .matrix-card-content, .matrix-card-blue-3 > .matrix-card-title {
  background-color: rgb(0, 128, 0);
}

.matrix-card-green-1 > .matrix-card-content, .matrix-card-green-1 > .matrix-card-title {
  background-color: rgba(75, 145, 209);
}

.matrix-card-green-2 > .matrix-card-content, .matrix-card-green-2 > .matrix-card-title {
  background-color: rgba(45, 112, 173);
}

.matrix-card-green-3 > .matrix-card-content, .matrix-card-green-3 > .matrix-card-title {
  background-color: rgba(33, 83, 129);
}

.matrix-card-red-1 > .matrix-card-content, .matrix-card-red-1 > .matrix-card-title {
  background-color: rgba(242, 0, 0);
}

.matrix-card-red-2 > .matrix-card-content, .matrix-card-red-2 > .matrix-card-title {
  background-color: rgba(255, 37, 37);
}

.matrix-card-yellow-3 > .matrix-card-content, .matrix-card-yellow-3 > .matrix-card-title {
  background-color: rgba(255, 123, 33);
}

.matrix-result .matrix-card-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.matrix-result .matrix-card-content .label-result {
  font-size: 13px;
  font-weight: 700;
  text-align: center;
}

.matrix-result .matrix-card-content .label-result strong {
  color: black;
}

@media screen and (max-width: 480px) {    
  .matrix {
    display: block;
    grid-template-columns: 35px 1fr;
  }

  .matrix-row {
    display: block;
    grid-template-columns: 35px repeat(3, 1fr);
  }

  .matrix-left-title {
    text-align: left;
    writing-mode: horizontal-tb;
  }

  .matrix-left-title span {
    transform: rotate(0deg);
  }

  .matrix-bottom-title {
    text-align: right;
  }

  .matrix-label {
    writing-mode: horizontal-tb;
  }

  .matrix-label span {
    transform: rotate(0deg);
  }

  .matrix-label span {
    direction: ltr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Manager/Evaluation/InfoPDI9Box.vue